import { render, staticRenderFns } from "./PermissionsCell.vue?vue&type=template&id=cdcc5840&"
import script from "./PermissionsCell.vue?vue&type=script&lang=js&"
export * from "./PermissionsCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports